import { isEnglishTestRoute, t, useLanguage } from '@/lib/i18n'
import { useLocation } from 'react-router-dom'
// Direct import, not the barrel: the router loads this file eagerly and the barrel would pull every r5 component into the entry chunk.
import { Skeleton, SkeletonGroup } from '@/components/r5/Skeleton'
import './r5-system.css'

/**
 * A page-shaped skeleton for a route that is still loading (PAGES 3.21): heading, lede and two card blocks inside `.r5`,
 * one visually hidden "Loading" status and no spinner. Static (no shimmer).
 */
export function PageSkeleton() {
  useLanguage()
  return (
    <div className="r5 r5-pageskel">
      <SkeletonGroup label={t('Loading')} className="r5-pageskel__in">
        <Skeleton variant="line" width="40%" className="r5-pageskel__h" />
        <Skeleton variant="line" width="70%" />
        <div className="r5-pageskel__cards">
          <Skeleton variant="block" />
          <Skeleton variant="block" />
        </div>
      </SkeletonGroup>
    </div>
  )
}

/**
 * What a route shows while its chunk or session loads. The exam room (and the runner preview) keeps the plain status line it
 * had, because nothing r5 is ever mounted around it; every other page, the admin pages included, gets the skeleton.
 */
export function RouteLoading() {
  useLanguage()
  const { pathname } = useLocation()
  if (isEnglishTestRoute(pathname)) return <div className="app-loading" role="status">{t('Loading')}</div>
  return <PageSkeleton />
}
